module.exports = __webpack_public_path__ + "static/media/goldwind.889d4c7b.png";